export enum LayerType {
  APP_LAYER = 'APP_LAYER',
  ATLAS_LAYER = 'ATLAS_LAYER',
  OSM_LAYER = 'OSM_LAYER',
}
